import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problem from "@/components/Problem";
import Solution from "@/components/Solution";
import Services from "@/components/Services";
import Advantage from "@/components/Advantage";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-ink p-8 text-center">
                    <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">
                        System fault — reload to retry.
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <BrowserRouter>
            <ErrorBoundary>
                <div className="relative min-h-screen bg-ink font-sans text-slate-100">
                    <div className="grain" aria-hidden="true" />
                    <Nav />
                    <main>
                        <Hero />
                        <Marquee />
                        <Problem />
                        <Solution />
                        <Services />
                        <Advantage />
                        <FinalCTA />
                    </main>
                    <Footer />
                </div>
            </ErrorBoundary>
        </BrowserRouter>
    );
}

export default App;
